export const SHOW_NOTIFICATION = 'NOTIFICATION/SHOW_NOTIFICATION';
export const SHOW_LOADING = 'NOTIFICATION/SHOW_LOADING';
export const HIDE_NOTIFICATION = 'NOTIFICATION/HIDE_NOTIFICATION';



// WEBPACK FOOTER //
// ./src/action_types/notificationActionTypes.ts